import { Injectable } from '@angular/core';

import { IConfirmableInjectedAction } from '../interfaces';
import { InjectedFailedCasesMigration } from '../components/worklist/injected-actions/data-migration/failed-cases-data-migration';
import { InjectedManageTags } from '../components/worklist/injected-actions/manage-tags';
import { InjectedOrganizationAccessAction } from '../components/worklist/injected-actions/Admin/organization-access-user-action';
import { InjectedPNCClinicalDate } from '../components/worklist/injected-actions/PNC/update-clinical-date';
import { InjectedTriggerMigrationChunkRollback } from '../components/worklist/injected-actions/data-migration/trigger-data-migration-chunk-rollback';
import { InjectedTriggerMigrationRollback } from '../components/worklist/injected-actions/data-migration/trigger-data-migration-rollback';
import { InjectedUserActivationRetrigger } from '../components/worklist/injected-actions/Admin/retrigger-user-activation';
import { InjectedValidateMigration } from '../components/worklist/injected-actions/data-migration/validate-data-migration';

@Injectable({
  providedIn: 'root'
})
export class InjectedActionsFactoryService {

  private callbackClasses: Map<string, IConfirmableInjectedAction> = new Map();

  constructor() {
    this.callbackClasses.set('setPNCDate', new InjectedPNCClinicalDate());
    this.callbackClasses.set('manageTags', new InjectedManageTags());
    this.callbackClasses.set('validateMigration', new InjectedValidateMigration());
    this.callbackClasses.set('triggerMigrationRollback', new InjectedTriggerMigrationRollback());
    this.callbackClasses.set('showFailedMigrationData', new InjectedFailedCasesMigration());
    this.callbackClasses.set('userActivationRetrigger', new InjectedUserActivationRetrigger());
    this.callbackClasses.set('triggerMigrationChunkRollback', new InjectedTriggerMigrationChunkRollback());
    this.callbackClasses.set('InjectedOrganizationAccessAction', new InjectedOrganizationAccessAction());
  }

  getClass(actionCallbackClassName: string) {
    return this.callbackClasses.get(actionCallbackClassName);
  }
}
